import * as TK from 'components/comments/Comment/translations/constants';
import { Translations } from 'translations/types';

export const commentEnUsLocale: Translations = {
  [TK.COMMENT_AGO]: 'ago',
  [TK.COMMENT_LIKE]: 'Like',
  [TK.COMMENT_REPLY]: 'Reply',
  [TK.COMMENT_REPLIES]: 'Replies',
};
